// Decision 9d (Carla, 2026-10-12): a calendar preference saved in Settings applies at once, with no
// reload. Settings > Calendar announces what the SERVER holds after a save (read back, never what
// was sent); each reader listens: the default view (hooks/useCalendarDefaultTab, App.js), the week
// view and the month view. Tested in components/Settings/CalendarPrefsLive.test.js.

export const CALENDAR_PREFS_EVENT = 'aidey:calendarPrefsUpdated';

/** Tell every open reader the calendar preferences the server now holds. */
export function announceCalendarPrefs(prefs) {
  if (!prefs || typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(CALENDAR_PREFS_EVENT, { detail: prefs }));
}

/** Listen for saved calendar preferences. Returns the unsubscribe, for a useEffect cleanup. */
export function onCalendarPrefs(handler) {
  if (typeof window === 'undefined') return () => {};
  const listener = (e) => { if (e && e.detail) handler(e.detail); };
  window.addEventListener(CALENDAR_PREFS_EVENT, listener);
  return () => window.removeEventListener(CALENDAR_PREFS_EVENT, listener);
}

// The Settings value -> the Tasks page tab it opens on.
const TAB_FOR_VIEW = { week: 'week', month: 'calendar', day: 'today' };
export function calendarTabFor(defaultView) {
  return TAB_FOR_VIEW[defaultView] || 'week';
}
